import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { AuthenticationStrategyType, SwitchUserFormValues } from "./types";
import { schema } from "./constants";

export interface SwitchUserFormProviderProps {
  children?: React.ReactNode;
  talinkUsername: string;
  authStrategy: AuthenticationStrategyType;
  identifier?: string;
}

export const SwitchUserFormProvider = ({
  children,
  talinkUsername,
  authStrategy,
  identifier,
}: SwitchUserFormProviderProps) => {
  const methods = useForm<SwitchUserFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      authStrategy,
      talinkUsername,
      identifier: identifier,
      password: undefined,
      mfaCode: undefined,

      // UI
      mfaRequired: false,
      mfaCodeSent: false,
      mfaStrategies: [],
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
